<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
const wheelImage = `${import.meta.env.VITE_AWS_STORAGE_URL}/contest-games/roue-cadeau.png`

defineProps<{
  isButtonLoading: boolean
}>()
const { t } = useI18n()

const arrowStart = ref<HTMLElement>(null)
const leftDiv = ref<HTMLElement>(null)

const startTop = computed(
  () => `${leftDiv.value?.offsetHeight - leftDiv.value?.offsetTop - arrowStart.value?.offsetTop}px`
)

const startLeft = computed(
  () => `${leftDiv.value?.offsetWidth - leftDiv.value?.offsetLeft - arrowStart.value?.offsetLeft}px`
)

const googlePlaceId = ref<string | null>(null)

const emit = defineEmits<(e: 'submitGooglePage', googlePlaceId: string) => void>()

const submitGooglePage = () => {
  if (!googlePlaceId.value) return
  emit('submitGooglePage', googlePlaceId.value)
}
</script>
<template>
  <LeafletLayout>
    <template #leftSection>
      <div class="relative z-10 flex h-full flex-col justify-around">
        <p class="mb-12 inline-block leading-10">
          🥷 {{ t('pages.contests.successConfig.title1') }}
          <span class="whitespace-nowrap rounded-md bg-yellow-300 px-2 py-[5px] font-bold text-primary">Hey Pongo</span>
          {{ t('pages.contests.successConfig.title2') }}
          <span
            ref="leftDiv"
            class="relative whitespace-nowrap rounded-md bg-yellow-300 px-2 py-[5px] font-bold text-primary"
            >{{ t('pages.contests.successConfig.gameContest') }}
          </span>
        </p>
        <img class="m-auto max-h-96" :src="wheelImage" alt="Image décorative" />
      </div>
    </template>
    <template #rightSection>
      <div ref="rightDiv">
        <form class="mt-20 flex w-full flex-col justify-center lg:mt-[calc(50dvh)]" @submit.prevent="submitGooglePage">
          <label for="autocompleteString" class="mb-5 font-extrabold text-foreground">
            {{ t('pages.contests.successConfig.googleLabel') }} 👇</label
          >
          <AppGooglePlaceIdAutoComplete v-model="googlePlaceId" />
          <Button
            type="submit"
            variant="default-primary"
            class="ml-auto mr-0 mt-6 flex w-min"
            :disabled="isButtonLoading || !googlePlaceId"
          >
            <Loader2 v-if="isButtonLoading" class="animate-spin" />
            {{ t('pages.contests.successConfig.continueButton') }}
          </Button>
        </form>
      </div>
    </template>
  </LeafletLayout>
</template>

<style>
.arrow {
  position: absolute;
  left: v-bind(startLeft);
  top: v-bind(startTop);
}
</style>
